import { initializeApp } from 'firebase';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { addLocaleData } from 'react-intl';
import * as enLocale from 'react-intl/locale-data/en';
import AccountView from './account/AccountView';
import { Api } from './api/Api';
import { App, IAppStore } from './app/App';
import {CameraStore, ICameraStore} from './components/camera/CameraStore';
import CameraView from './components/camera/CameraView';
import conf from './conf';
import { DiaryPageStore, IDiaryPageStore } from './diary/DiaryPageStore';
import DiaryPageView from './diary/DiaryPageView';
import { AddDrinkStore, IAddDrinkStore } from './diary/drink/add/AddDrinkStore';
import AddDrinkView from './diary/drink/add/AddDrinkView';
import { AddMealStore, IAddMealStore } from './diary/meal/add/AddMealStore';
import AddMealView from './diary/meal/add/AddMealView';
import { AddMeasurementStore, IAddMeasurementStore } from './diary/measurement/add/AddMeasurementStore';
import AddMeasurementView from './diary/measurement/add/AddMeasurementView';
import { AddTrainingStore, IAddTrainingStore } from './diary/training/add/AddTrainingStore';
import AddActivityView from './diary/training/add/AddTrainingView';
import { AddWaterStore, IAddWaterStore } from './diary/water/add/AddWaterStore';
import AddWatherView from './diary/water/add/AddWaterView';
import firebaseConfig from './firebaseConfig';
import './index.css';
import { LocaleStore } from './intl';
import * as serviceWorker from './registerServiceWorker';
import { createRouteStore, IRouteStore } from './RouteStore';
import SettingsView from './settings/SettingsView';
import en from './translations/en';
import { createUserStore, IUserStore } from './user/UserStore';

// Internationalization
addLocaleData([...enLocale]);

window.console.log(`env: ${process.env.REACT_APP_STAGE}`)

const api = new Api(conf.url);

const locale: LocaleStore = new LocaleStore('en', { en });

const app = initializeApp(firebaseConfig);

const addMeal: IAddMealStore = new AddMealStore(api);

const addMeasurement: IAddMeasurementStore = new AddMeasurementStore(api);

const addTraining: IAddTrainingStore = new AddTrainingStore(api);

const addWater: IAddWaterStore = new AddWaterStore(api);

const addDrink: IAddDrinkStore = new AddDrinkStore(api);

const camera: ICameraStore = new CameraStore();

const diaryPage: IDiaryPageStore = new DiaryPageStore(api);

const user: IUserStore = createUserStore(app.auth(), api);

const routes: IRouteStore = createRouteStore([
  {
    getPath: () => '/account',
    id: 'account',
    render: () => <AccountView/>
  },
  {
    getPath: () => '/camera',
    id: 'camera',
    render: () => <CameraView/>
  },
  {
    getPath: () => '/diary',
    id: 'diary',
    render: () => <DiaryPageView/>
  },
  {
    getPath: () => '/diary/activity/add',
    id: 'diary-activity-add',
    render: () => <AddActivityView/>
  },
  {
    getPath: () => '/diary/meal/add',
    id: 'diary-meal-add',
    render: () => <AddMealView/>
  },
  {
    getPath: () => '/diary/measurement/add',
    id: 'diary-measurement-add',
    render: () => <AddMeasurementView/>
  },
  {
    getPath: () => '/diary/wather/add',
    id: 'diary-wather-add',
    render: () => <AddWatherView/>
  },
  {
    getPath: () => '/diary/drink/add',
    id: 'diary-drink-add',
    render: () => <AddDrinkView/>
  },
  {
    getPath: () => '/settings',
    id: 'settings',
    render: () => <SettingsView/>
  }
]);

routes.navigate('diary');

const appStore: IAppStore = {
  addDrink,
  addMeal,
  addMeasurement,
  addTraining,
  addWater,
  camera,
  diaryPage,
  locale,
  routes,
  user
}

ReactDOM.render(
  <App store={appStore} />,
  document.getElementById('root') as HTMLElement
);

serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.tsx